jQuery(document).ready(function () {
	// Sliders
	$('.layout--mini-template .carousel').each(function(index){
	    var $container = $(this)

	    $container
        .slick({
            dots: true,
            infinite: false,
            speed: 300,
            slidesToShow: 1,
            slidesToScroll: 1
        });
	});
});
